module.exports = __webpack_public_path__ + "img/img-newsletter.c8c796a3.jpg";